import React from 'react';
import { Box, Text, Image, Link } from '@chakra-ui/react';
import service_expired from 'assets/access_denied.png';

const ServiceExpired = () => {
  return (
    <Box
      textAlign="center"
      borderRadius="md"
      boxShadow="md"
      p={2}
      bg="gray.50"
      maxW="600px"
      ml="auto"
      mr="auto"
      mt={20}
      mb={4}
    >
      <Image src={service_expired} alt="Access Denied" w="100%" />
      <Text fontSize="2xl" fontWeight="bold" color="red.600">
        Service Expired
      </Text>
      <Text fontSize="md" color="gray.600" mt={2}>
        Your free trial or subscription has expired.{' '}
        <Link color="blue.500" cursor="pointer" href="/pricing">
          Renew
        </Link>{' '}
        now to continue enjoying full access to all features.
      </Text>
    </Box>
  );
};

export default ServiceExpired;
